import { type ReactNode, useId } from 'react';
import clsx from 'clsx';
import styles from './radio.module.scss';

interface IRadio {
  // ADDITIONAL PROPS
  className?: string;
  right?: boolean;
  fullWidth?: boolean;
  // BASE PROPS
  name?: string;
  disabled?: boolean;
  checked?: boolean;
  value?: string | number | readonly string[];
  onChange?: (value: string) => void;
  children?: ReactNode;
}

export const Radio = (props: IRadio) => {
  const id = useId();

  return (
    <div
      className={clsx(
        'flex h-[22px] items-center',
        styles.container,
        props.right && styles.right,
        props.fullWidth && styles.fullWidth,
        props.className,
      )}
    >
      <input
        id={id}
        className={clsx('m-0 h-[15px] w-[15px] align-top', styles.input)}
        type='radio'
        name={props.name}
        disabled={props.disabled}
        value={props.value}
        checked={props.checked}
        onChange={(e) => props.onChange?.(e.target.value)}
      />
      <label htmlFor={id} className={clsx('flex w-full cursor-pointer items-center justify-start text-sm text-[#ccaf8099]', styles.label)}>
        <span
          className={clsx(
            'mr-2.5 flex h-[22px] w-[22px] items-center justify-center rounded-full border border-[#ccaf8099] bg-transparent',
            styles.marker,
          )}
        >
          <span className={clsx('h-[12px] w-[12px] rounded-full bg-[#ccaf8099] transition-opacity duration-200', styles.dot)} />
        </span>
        <span>{props.children}</span>
      </label>
    </div>
  );
};
